

import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';

const AllApplications = () => {
  const [formData, setFormData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [viewData, setViewData] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);

  const itemsPerPage = 10;

 const navi =useNavigate()
  useEffect(() => {
    const role = localStorage.getItem("userRole");
    if (role !== "supperadmin") {
      // alert("Access denied. You do not have permission to view this page.");
      navi("/"); // redirect to home or login page
    }
  }, [navi]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API}/auth/isappalayed`);
        setFormData(response.data);
      } catch (err) {
        setError('Failed to fetch data.');
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const handleView = async (id) => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API}/auth/view/${id}`);
      setViewData(response.data);
      setShowModal(true);
    } catch (error) {
      console.error('Error fetching view data:', error);
    }
  };

  const overlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000
  };

  const modalStyle = {
    background: '#fff',
    padding: '30px',
    borderRadius: '10px',
    width: '90%',
    maxWidth: '600px',
    maxHeight: '80vh',
    overflowY: 'auto',
    boxShadow: '0 4px 8px rgba(0,0,0,0.3)'
  };

  const closeBtnStyle = {
    marginTop: '20px',
    background: '#e74c3c',
    color: 'white',
    border: 'none',
    padding: '10px 20px',
    cursor: 'pointer',
    borderRadius: '5px'
  };

  const filteredData = formData.filter((item) =>
    item.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentData = filteredData.slice(startIndex, startIndex + itemsPerPage);

  return (
    <div>
      <div style={{ marginBottom: '50px' }}>
        <Link to="/" className="logo_image">
          <img src="assets/headimg.jpg" alt="Logo" style={{ width: '100%' }} />
        </Link>
      </div>

      <div className="container" style={{ maxWidth: '1500px', margin: '0 auto', backgroundColor: '#f9f9f9', padding: '20px', borderRadius: '10px', boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)' }}>
        <input
          type="text"
          placeholder="Search by student name..."
          value={searchTerm}
          style={{ padding: '10px', border: '2px solid #ccc', borderRadius: '5px', width: '100%', maxWidth: '400px', marginBottom: '20px' }}
          onChange={(e) => {
            setSearchTerm(e.target.value);
            setCurrentPage(1);
          }}
        />
        <h4><span>Total Application: </span><strong>{formData.length}</strong></h4>

        <div style={{ overflowX: 'auto' }}>
          {loading ? (
            <p>Loading...</p>
          ) : error ? (
            <p style={{ color: 'red' }}>{error}</p>
          ) : (
            <table border="1" cellPadding="10" style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Student Name</th>
                  <th>FATHER NAME</th>
                  <th>UserID</th>
                  <th>STANDARD</th>
                  <th>Student ID</th>
                  <th>View</th>
                </tr>
              </thead>
              <tbody>
                {currentData.length > 0 ? (
                  currentData.map((item, index) => (
                    <tr key={item.id}>
                      <td>{startIndex + index + 1}</td>
                      <td>{item.name}</td>
                      <td>{item.father_name}</td>
                      <td>{item.UserId}</td>
                      <td>{item.standard}</td>
                      <td>{item.student_id}</td>
                      <td><button onClick={() => handleView(item.id)}>View</button></td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" style={{ textAlign: 'center' }}>No data available</td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </div>

        <div style={{ marginTop: '20px', textAlign: 'center' }}>
          <button onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))} disabled={currentPage === 1}>Previous</button>
          <span style={{ margin: '0 10px' }}>Page {currentPage} of {totalPages}</span>
          <button onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))} disabled={currentPage === totalPages}>Next</button>
        </div>
      </div>

      {/* Modal Popup */}
      {showModal && viewData && (
        <div style={overlayStyle}>
          <div style={modalStyle}>
            <h2 style={{ marginBottom: '15px' }}>Student Details</h2>
            <table style={{ width: '100%', lineHeight: '1.6' }}>
              <tbody>
                <tr><td><strong>Name:</strong></td><td>{viewData.name}</td></tr>
                <tr><td><strong>Father's Name:</strong></td><td>{viewData.father_name}</td></tr>
                <tr><td><strong>User ID:</strong></td><td>{viewData.UserId}</td></tr>
                <tr><td><strong>Student ID:</strong></td><td>{viewData.student_id}</td></tr>
                <tr><td><strong>Standard:</strong></td><td>{viewData.standard}</td></tr>
                <tr><td><strong>Medium:</strong></td><td>{viewData.medium}</td></tr>
                <tr><td><strong>School:</strong></td><td>{viewData.school}</td></tr>
                <tr><td><strong>Payment Status:</strong></td><td>{viewData.payment_status}</td></tr>
                <tr><td><strong>Order ID:</strong></td><td>{viewData.orderId || 'N/A'}</td></tr>
                <tr><td><strong>Referral ID:</strong></td><td>{viewData.referralId || 'N/A'}</td></tr>
                <tr>
                  <td><strong>Photo:</strong></td>
                  <td>
                    <img
                      src={`${process.env.REACT_APP_API}/uploads/${viewData.photo_path}`}
                      alt="Student"
                      width="100"
                      style={{ cursor: 'pointer' }}
                      onClick={() => setPreviewImage(`${process.env.REACT_APP_API}/uploads/${viewData.photo_path}`)}
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>Bonafide:</strong></td>
                  <td>
                    <img
                      src={`${process.env.REACT_APP_API}/uploads/${viewData.bonafide_path}`}
                      alt="Bonafide"
                      width="100"
                      style={{ cursor: 'pointer' }}
                      onClick={() => setPreviewImage(`${process.env.REACT_APP_API}/uploads/${viewData.bonafide_path}`)}
                    />
                  </td>
                </tr>
              </tbody>
            </table>
            <button style={closeBtnStyle} onClick={() => setShowModal(false)}>Close</button>
          </div>
        </div>
      )}

      {/* Full Image Preview */}
      {previewImage && (
        <div style={{ ...overlayStyle, backgroundColor: 'rgba(0, 0, 0, 0.8)', cursor: 'zoom-out' , flexDirection: 'column',justifyContent: 'center',alignItems: 'center'}} onClick={() => setPreviewImage(null)}>
             <div
      style={{
        alignSelf: 'flex-end',
        padding: '10px',
        color: 'white',
        fontSize: '24px',
        cursor: 'pointer',
        backgroundColor:"red",
        // borderRadius:"50%"
      }}
      onClick={() => setPreviewImage(null)}
    >
     &larr; Back
    </div>
          <img
            src={previewImage}
            alt="Full Preview"
            style={{ maxWidth: '90%', maxHeight: '90%', borderRadius: '8px', boxShadow: '0 0 20px rgba(0,0,0,0.5)' }}
          />
        </div>
      )}
    </div>
  );
};

export default AllApplications;